// Asset without campaign details
export const ANALYTICS_CARD_DATA = {
  LOAD: 'ANALYTICS_DASHBOARD_DATA_LOAD',
  SUCCESS: 'ANALYTICS_DASHBOARD_DATA_LOAD_SUCCESS',
  FAIL: 'ANALYTICS_DASHBOARD_DATA_LOAD_FAIL',
  RESET: 'ANALYTICS_DASHBOARD_DATA_LOAD_RESET',
  SET_REDIRECT_URL: 'ANALYTICS_DASHBOARD_DATA_SET_REDIRECT_URL',
  FILTER_RESET: 'ANALYTICS_DASHBOARD_DATA_FILTER_RESET',
  RENDER_DONE: 'ANALYTICS_CARD_DATA_RENDER_DONE',
  SET_FIRST_ALL_DATA_SHOWN: 'ANALYTICS_CARD_DATA_SET_FIRST_ALL_DATA_SHOWN',
};
export const ANALYTICS_INTENT_DATA = {
  LOAD: 'ANALYTICS_INTENT_DATA_LOAD',
  SUCCESS: 'ANALYTICS_INTENT_DATA_LOAD_SUCCESS',
  FAIL: 'ANALYTICS_INTENT_DATA_LOAD_FAIL',
  EXPORT_LOAD: 'ANALYTICS_INTENT_DATA_EXPORT_LOAD',
  RESET: 'ANALYTICS_INTENT_DATA_LOAD_RESET',
};

export const GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST = {
  LOAD: 'GET_ANALYTICS_CAMPAIGNS_FILTERS_LIST_LOAD',
  SUCCESS: 'GET_ANALYTICS_CAMPAIGNS_FILTERS_LIST_SUCCESS',
  FAIL: 'GET_ANALYTICS_CAMPAIGNS_FILTERS_LIST_FAIL',
  RESET: 'GET_ANALYTICS_CAMPAIGNS_FILTERS_LIST_RESET',
  SET_FILTERS: 'GET_ANALYTICS_CAMPAIGNS_FILTERS_LIST_SET_FILTERES',
  FILTER_EMAILS: 'GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST_FILTER_EMAILS',
};

export const GET_ANALYTICS_FILTERS_DROPDOWN_DATA = {
  CAMPAIGN_AND_WORKFLOW_LOAD: 'GET_ANALYTICS_FILTERS_CAMPAIGN_AND_WORKFLOW_DROPDOWN_DATA_LOAD',
  CAMPAIGN_AND_WORKFLOW_SUCCESS: 'GET_ANALYTICS_FILTERS_CAMPAIGN_AND_WORKFLOW_DROPDOWN_DATA_SUCCESS',
  CAMPAIGN_AND_WORKFLOW_FAIL: 'GET_ANALYTICS_FILTERS_CAMPAIGN_AND_WORKFLOW_DROPDOWN_DATA_FAIL',
  RESET_CAMPAIGNS_AND_WORKFLOWS:
    'GET_ANALYTICS_FILTERS_CAMPAIGN_AND_WORKFLOW_DROPDOWN_DATA_RESET_CAMPAIGNS_AND_WORKFLOWS',
  EMAIL_LOAD: 'GET_ANALYTICS_FILTERS_EMAIL_DROPDOWN_DATA_LOAD',
  EMAIL_SUCCESS: 'GET_ANALYTICS_FILTERS_EMAIL_DROPDOWN_DATA_SUCCESS',
  EMAIL_FAIL: 'GET_ANALYTICS_FILTERS_EMAIL_DROPDOWN_DATA_FAIL',
  EMAIL_RESET: 'GET_ANALYTICS_FILTERS_EMAIL_DROPDOWN_DATA_RESET',
  SEARCH_EMAIL_RESET: 'GET_ANALYTICS_FILTERS_EMAIL_DROPDOWN_DATA_SEARCH_RESET',
  SET_EMAIL_MARKED_COUNT: 'GET_ANALYTICS_FILTERS_DROPDOWN_DATA_SET_EMAIL_MARKED_COUNT',
};

export const GET_ANALYTICS_CAMPAIGNS_FILTERS = {
  RESET: 'GET_ANALYTICS_CAMPAIGNS_FILTERS_RESET',
  SET_FILTERS: 'GET_ANALYTICS_CAMPAIGNS_FILTERS_SET_FILTERES',
  REORDER_CAMPAIGNS: 'GET_ANALYTICS_CAMPAIGNS_FILTERS_REORDER',
  SET_SHARE_PROFILE_FILTER: 'GET_ANALYTICS_CAMPAIGNS_FILTERS_SET_SHARE_PROFILE_FILTER',
  SET_DAILY_IQ_FILTER: 'GET_ANALYTICS_CAMPAIGNS_FILTERS_SET_DAILY_IQ_FILTER',
  SET_WEEKLY_ACCOUNTS_INSIGHTS_FILTER: 'GET_ANALYTICS_CAMPAIGNS_FILTERS_SET_WEEKLY_ACCOUNTS_INSIGHTS_FILTER',
  RESET_CONSTANT_FILTERS: 'GET_ANALYTICS_CAMPAIGNS_FILTERS_RESET_CONSTANT_FILTERS',
  SET_WORKFLOW_FILTER: 'SET_WORKFLOW_FILTER',
};

export const GET_ANALYTICS_ASSETS_FILTERS = {
  RESET: 'GET_ANALYTICS_ASSETS_FILTERS_RESET',
  SET_FILTERS: 'GET_ANALYTICS_ASSETS_FILTERS_SET_FILTERES',
  REORDER_ASSETS: 'GET_ANALYTICS_ASSETS_FILTERS_REORDER_ASSETS',
  SET_TEST_EMAIL_FILTER: 'GET_ANALYTICS_ASSETS_FILTERS_SET_TEST_EMAIL_FILTER',
  RESET_TEST_EMAIL_FILTER: 'GET_ANALYTICS_ASSETS_FILTERS_RESET_TEST_EMAIL_FILTER',
};

export const GET_ANALYTICS_WORKFLOW_FILTERS = {
  SET_FILTERS: 'GET_ANALYTICS_WORKFLOW_SET_FILTERS',
};

export const GET_ANALYTICS_WORKFLOW_LIST = {
  LOAD: 'GET_ANALYTICS_WORKFLOW_LIST_LOAD',
  SUCCESS: 'GET_ANALYTICS_WORKFLOW_LIST_SUCCESS',
  FAIL: 'GET_ANALYTICS_WORKFLOW_LIST_FAIL',
  RESET: 'GET_ANALYTICS_WORKFLOW_LIST_RESET',
  REORDER: 'GET_ANALYTICS_WORKFLOW_LIST_REORDER',
};

export const ANALYTICS_DASHBOARD_WORKFLOW = {
  SELECT: 'ANALYTICS_DASHBOARD_WORKFLOW_SELECT',
  SET: 'ANALYTICS_DASHBOARD_WORKFLOW_SET',
  RESET: 'ANALYTICS_DASHBOARD_WORKFLOW_RESET',
  FIRST_TIME_SET: 'ANALYTICS_DASHBOARD_WORKFLOW_FIRST_TIME_SET',
  SELECTED_RESET: 'ANALYTICS_DASHBOARD_WORKFLOW_SELECTED_RESET',
};

export const ANALYTICS_DASHBOARD_GRAPH_DATA = {
  LOAD: 'ANALYTICS_DASHBOARD_GRAPH_DATA_LOAD',
  LOAD_SUCCESS: 'ANALYTICS_DASHBOARD_GRAPH_DATA_LOAD_SUCCESS',
  LOAD_FAIL: 'ANALYTICS_DASHBOARD_GRAPH_DATA_LOAD_FAIL',
  CLEAR: 'ANALYTICS_DASHBOARD_GRAPH_DATA_CLEAR',
  SET_DATES: 'ANALYTICS_DASHBOARD_GRAPH_DATA_SET_DATES',
  RESET_DATES: 'ANALYTICS_DASHBOARD_GRAPH_DATA_RESET_DATES',
  SET_USER: 'ANALYTICS_DASHBOARD_GRAPH_DATA_SET_USER',
  SET_DATES_OBJECT: 'ANALYTICS_DASHBOARD_GRAPH_DATA_SET_DATES_OBJECT',
  SET_DELIVERED_EMAIL: 'ANALYTICS_DASHBOARD_GRAPH_DATA_SET_DELIVERED_EMAIL',
  SET_APPLIED_DATES_OBJECT: 'ANALYTICS_DASHBOARD_GRAPH_DATA_SET_APPLIED_DATES_OBJECT',
  SET_APPLIED_DATES: 'ANALYTICS_DASHBOARD_GRAPH_DATA_SET_APPLIED_DATES',
  EMAIL_LOAD: 'ANALYTICS_DASHBOARD_GRAPH_DATA_EMAIL_LOAD',
  EMAIL_LOAD_SUCCESS: 'ANALYTICS_DASHBOARD_GRAPH_DATA_EMAIL_LOAD_SUCCESS',
  EMAIL_RESET: 'ANALYTICS_DASHBOARD_GRAPH_DATA_EMAIL_RESET',
  SET_EMAIL_GRAPH_FILTER: 'ANALYTICS_DASHBOARD_GRAPH_DATA_EMAIL_FILTER_SET',
  SET_EMAIL_GRAPH_DATA_FILTERED: 'ANALYTICS_DASHBOARD_GRAPH_DATA_SET_FILTERED_EMAIL_DATA',
  SET_CAMPAIGN_GRAPH_FILTER: 'ANALYTICS_DASHBOARD_GRAPH_DATA_CAMPAIGN_FILTER_SET',
  CAMPAIGN_LOAD: 'ANALYTICS_DASHBOARD_GRAPH_DATA_CAMPAIGN_LOAD',
  CAMPAIGN_LOAD_SUCCESS: 'ANALYTICS_DASHBOARD_GRAPH_DATA_CAMPAIGN_LOAD_SUCCESS',
  CAMPAIGN_COUNT_SET: 'ANALYTICS_DASHBOARD_GRAPH_DATA_CAMPAIGN_COUNT_SET',
  CAMPAIGN_RESET: 'ANALYTICS_DASHBOARD_GRAPH_DATA_CAMPAIGN_RESET',
};

export const ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS = {
  SET: 'ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS_SET',
  RESET: 'ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS_RESET',
  SELECT_ALL: 'ANALYTICS_DASHBOARD_SELECT_ALL_SELECTED_CAMPAINGS',
  UNSELECT_ALL: 'ANALYTICS_DASHBOARD_UNSELECT_ALL_SELECTED_CAMPAINGS',
  SET_DEFAULT: 'ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS_SET_DEFAULT',
};

export const ANALYTICS_DASHBOARD = {
  SET_DEFAULT_FLAG: 'ANALYTICS_DASHBOARD_SET_DEFAULT_FLAG',
  SET_CAMPAIGN_LIMIT: 'ANALYTICS_DASHBOARD_SET_CAMPAIGN_LIMIT',
  SET_CAMPAIGN_FILTERS: 'ANALYTICS_DASHBOARD_SET_CAMPAIGN_SET',
  RESET_CAMPAIGN_FILTERS: 'ANALYTICS_DASHBOARD_RESET_CAMPAIGN_FILTERS',
  RESET_APPLIED_CAMPAIGN_FILTERS: 'ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS',
};

export const ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS = {
  SET: 'ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS_SET',
  UNSET: 'ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS_UNSET',
  RESET: 'ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS_RESET',
  REMOVE_QUERY_PARAMS_SET: 'ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS_REMOVE_QUERY_PARAMS_SET',
  REMOVE_QUERY_PARAMS_UNSET: 'ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS_REMOVE_QUERY_PARAMS_UNSET',
  UNSET_RESTRICT_EMAIL_DROPDOWN_PARAM: 'ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS_RESTRICT_EMAIL_DROPDOWN_PARAM',
};

export const ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS = {
  SET: 'ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS_SET',
  SET_MULTIPLE: 'ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS_SET_MULTIPLE',
  SELECT_ALL: 'ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS_SELECT_ALL',
  UNSELECT_ALL: 'ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS_UNSELECT_ALL',
  UNSELECT_MULTIPLE: 'ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS_UNSELECT_MULTIPLE',
  RESET: 'ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS_RESET',
  DATE_FILTER: 'ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS_DATE_FILTER',
  FILTER_LIST: 'ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS_FILTER_LIST',
  SET_SELECTED_ASSETS: 'ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS_SET_SELECTED_ASSETS',
  SET_EMAIL_DROPDOWN_USING_FILTER_ID: 'ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS_SET_EMAIL_DROPDOWN_USING_FILTER_ID',
};

export const ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS = {
  SET: 'ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS_SET',
  SELECT_ALL: 'ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS_SELECT_ALL',
  UNSELECT_ALL: 'ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS_UNSELECT_ALL',
  RESET: 'ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS_RESET',
  FILTER_LIST: 'ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS_FILTER_LIST',
};

export const ANALYTICS_CAMPAIGNS_SEARCH = {
  SET: 'ANALYTICS_CAMPAIGNS_SEARCH_SET',
  RESET: 'ANALYTICS_CAMPAIGNS_SEARCH_RESET',
};

export const ANALYTICS_ASSETS_SEARCH = {
  SET: 'ANALYTICS_ASSETS_SEARCH_SET',
  RESET: 'ANALYTICS_ASSETS_SEARCH_RESET',
  SET_FIRST_TIME: 'ANALYTICS_ASSETS_SEARCH_SET_FIRST_TIME',
};

export const ANALYTICS_WORKFLOWS_SEARCH = {
  SET: 'ANALYTICS_WORKFLOWS_SEARCH_SET',
  RESET: 'ANALYTICS_WORKFLOWS_SEARCH_RESET',
};

export const ANALYTICS_DATA_EXPORT = {
  SET_OPEN: 'ANALYTICS_DATA_EXPORT_SET_OPEN',
  SET_ERROR: 'ANALYTICS_DATA_EXPORT_SET_ERROR',
  SET_CLOSE: 'ANALYTICS_DATA_EXPORT_SET_CLOSE',
};

export const ANALYTICS_ACCOUNTS_DATA = {
  LOAD: 'ANALYTICS_ACCOUNTS_DATA_LOAD',
  LOAD_SUCCESS: 'ANALYTICS_ACCOUNTS_DATA_LOAD_SUCCESS',
  LOAD_FAIL: 'ANALYTICS_ACCOUNTS_DATA_LOAD_FAIL',
  RESET: 'ANALYTICS_ACCOUNTS_DATA_RESET',
  SELECTED_ACCOUNT: 'SELECTED_ACCOUNT',
  LOAD_MORE: 'ANALYTICS_ACCOUNTS_DATA_LOAD_MORE',
  LOAD_MORE_SUCCESS: 'ANALYTICS_ACCOUNTS_DATA_LOAD_MORE_SUCCESS',
  SELECTED_ACCOUNT_RESET: 'ANALYTICS_ACCOUNTS_DATA_SELECTED_ACCOUNT_RESET',
  SET_REDIRECT_URL: 'ANALYTICS_ACCOUNTS_DATA_SET_REDIRECT_URL',
  RESET_REDIRECT_URL: 'ANALYTICS_ACCOUNTS_DATA_RESET_REDIRECT_URL',
  SEARCH_RESET: 'ANALYTICS_ACCOUNTS_DATA_SEARCH_RESET',
  FILTER_RESET: 'ANALYTICS_ACCOUNTS_DATA_FILTER_RESET',
  SET_ACCOUNTS_BY_FILTER: 'ACCOUNTS_ANALYTICS_SET_ACCOUNTS_BY_FILTER',
};

//Contacts Analytics
export const CONTACT_ANALYTICS = {
  SET_TOTAL_UNIQUE_CONTACTS: 'CONTACT_ANALYTICS_SET_TOTAL_UNIQUE_CONTACTS',
  DELIVERED_LOAD: 'CONTACT_ANALYTICS_DELIVERED_LOAD',
  DELIVERED_SUCCESS: 'CONTACT_ANALYTICS_DELIVERED_SUCCESS',
  DELIVERED_FAIL: 'CONTACT_ANALYTICS_DELIVERED_FAIL',
  DELIVERED_RESET: 'CONTACT_ANALYTICS_DELIVERED_RESET',
  ALL_CONTACTS_LOAD: 'CONTACT_ANALYTICS_ALL_CONTACTS_LOAD',
  ALL_CONTACTS_SUCCESS: 'CONTACT_ANALYTICS_ALL_CONTACTS_SUCCESS',
  ALL_CONTACTS_FAIL: 'CONTACT_ANALYTICS_ALL_CONTACTS_FAIL',
  ALL_CONTACTS_RESET: 'CONTACT_ANALYTICS_ALL_CONTACTS_RESET',
  BOUNCED_LOAD: 'CONTACT_ANALYTICS_BOUNCED_LOAD',
  BOUNCED_SUCCESS: 'CONTACT_ANALYTICS_BOUNCED_SUCCESS',
  BOUNCED_FAIL: 'CONTACT_ANALYTICS_BOUNCED_FAIL',
  BOUNCED_RESET: 'CONTACT_ANALYTICS_BOUNCED_RESET',
  UNSUBSCRIBED_LOAD: 'CONTACT_ANALYTICS_UNSUBSCRIBED_LOAD',
  UNSUBSCRIBED_SUCCESS: 'CONTACT_ANALYTICS_UNSUBSCRIBED_SUCCESS',
  UNSUBSCRIBED_FAIL: 'CONTACT_ANALYTICS_UNSUBSCRIBED_FAIL',
  UNSUBSCRIBED_RESET: 'CONTACT_ANALYTICS_UNSUBSCRIBED_RESET',
  SET_SORT_PROPS: 'CONTACT_ANALYTICS_SET_SORT_PROPS',
  SELECTED_PERSON: 'CONTACT_ANALYTICS_SELECTED_PERSON',
  SELECTED_PERSON_RESET: 'CONTACT_ANALYTICS_SELECTED_PERSON_RESET',
  SET_CONTACTS_BY_FILTER: 'CONTACT_ANALYTICS_SET_CONTACTS_BY_FILTER',
  SET_SEARCH_TEST: 'SET_SEARCH_TEST',
  SET_TAB: 'SET_TAB',
  SET_REDIRECT_URL: 'CONTACT_ANALYTICS_SET_REDIRECT_URL',
  RESET_REDIRECT_URL: 'CONTACT_ANALYTICS_RESET_REDIRECT_URL',
  RESET_ALL: 'CONTACT_ANALYTICS_RESET_ALL',
  FILTER_RESET: 'CONTACT_ANALYTICS_FILTER_RESET',
  SEARCH_RESET: 'CONTACT_ANALYTICS_SEARCH_RESET',
  SET_UNSUB_BOUNCE_TOTAL_COUNT: 'CONTACT_ANALYTICS_SET_UNSUB_BOUNCE_TOTAL_COUNT',
  SET_UNSUB_BOUNCE_TOTAL_COUNT_LOADING: 'CONTACT_ANALYTICS_SET_UNSUB_BOUNCE_TOTAL_COUNT_LOADING',
  SET_BOUNCE_FILTER: 'SET_BOUNCE_FILTER',
  SET_BOUNCE_FILTER_FIRST_TIME: 'SET_BOUNCE_FILTER_FIRST_TIME',
  SET_DELIVERED_CONTACTS_SORTING: 'SET_DELIVERED_CONTACTS_SORTING',
  SET_ALL_CONTACTS_SORTING: 'SET_ALL_CONTACTS_SORTING',
  SET_BOUNCED_CONTACTS_SORTING: 'SET_BOUNCED_CONTACTS_SORTING',
  SET_UNSUBSCRIBED_CONTACTS_SORTING: 'SET_UNSUBSCRIBED_CONTACTS_SORTING',
};
//Contacts inner details Analytics
export const CONTACTS_INNER_ANALYTICS = {
  RESET_CONTACT_DETAILS: 'CONTACT_ANALYTICS_RESET_CONTACT_DETAILS',
  CONTENT_RESET: 'CONTACT_ANALYTICS_CONTENT_RESET',
  CONTENT_LOAD: 'CONTACT_ANALYTICS_CONTENT_LOAD',
  CONTENT_SUCCESS: 'CONTACT_ANALYTICS_CONTENT_SUCCESS',
  CONTENT_FAIL: 'CONTACT_ANALYTICS_CONTENT_FAIL',
  DASHBOARD_LOAD: 'CONTACT_ANALYTICS_DASHBOARD_LOAD',
  DASHBOARD_SUCCESS: 'CONTACT_ANALYTICS_DASHBOARD_SUCCESS',
  DASHBOARD_FAIL: 'CONTACT_ANALYTICS_DASHBOARD_FAIL',
  DASHBOARD_RESET: 'CONTACT_ANALYTICS_DASHBOARD_RESET',
  CAMPAINGS_LOAD: 'CONTACT_ANALYTICS_CAMPAINGS_LOAD',
};

export const CONTACT_AUDIT_TRAIL = {
  LOAD: 'CONTACT_AUDIT_TRAIL_LOAD',
  SUCCESS: 'CONTACT_AUDIT_TRAIL_SUCCESS',
  FAIL: 'CONTACT_AUDIT_TRAIL_LOAD_FAIL',
  RESET: 'CONTACT_AUDIT_TRAIL_RESET',
};

export const CONTACT_AUDIT_TRAIL_DATE_FILTER = {
  RESET: 'CONTACT_AUDIT_TRAIL_DATE_FILTER_RESET',
  SET_CATEGORY: 'CONTACT_AUDIT_TRAIL_DATE_FILTER_SET_CATEGORY',
  SET_DATE: 'CONTACT_AUDIT_TRAIL_DATE_FILTER_SET_DATE',
};

export const CONTENT_ANALYTICS = {
  LOAD: 'CONTENT_ANALYTICS_LOAD',
  LOAD_SUCCESS: 'CONTENT_ANALYTICS_LOAD_SUCCESS',
  LOAD_FAIL: 'CONTENT_ANALYTICS_LOAD_FAIL',
  RESET: 'CONTENT_ANALYTICS_RESET',
  LOAD_MORE: 'CONTENT_ANALYTICS_LOAD_MORE',
  LOAD_MORE_SUCCESS: 'CONTENT_ANALYTICS_LOAD_MORE_SUCCESS',
  SET_SEARCH: 'CONTENT_ANALYTICS_CONTENT_ANALYTICS_SET_SEARCH',
  FILTER_RESET: 'CONTENT_ANALYTICS_CONTENT_ANALYTICS_FILTER_RESET',
  SEARCH_RESET: 'CONTENT_ANALYTICS_CONTENT_ANALYTICS_SEARCH_RESET',
  CLICKED_CONTACTS_SORT: 'CONTENT_ANALYTICS_CLICKED_CONTACTS_SORT',
  LOAD_CONTACTS: 'CONTENT_ANALYTICS_LOAD_CONTACTS',
  LOAD_CONTACTS_SUCCESS: 'CONTENT_ANALYTICS_LOAD_CONTACTS_SUCCESS',
  RESET_CONTATCS: 'CONTENT_ANALYTICS_CONTACTS_RESET',
  RESET_CONTACTS_ONLY: 'CONTENT_ANALYTICS_CONTACTS_RESET_ONLY',
  RESET_ARTILCE_DATA: 'CONTENT_ANALYTICS_ARTICLE_DATA_RESET',
  CONTACTS_FAIL: 'CONTENT_ANALYTCS_CONTACTS_FAIL',
};

export const ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS = {
  LOAD: 'ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS_LOAD',
  LOAD_SUCCESS: 'ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS_LOAD_SUCCESS',
  LOAD_FAIL: 'ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS_LOAD_FAIL',
  RESET: 'ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS_RESET',
  LOAD_MORE: 'ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS_LOAD_MORE',
  LOAD_MORE_SUCCESS: 'ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS_LOAD_MORE_SUCCESS',
  SET_SELECTED_CAMPAIGNS: 'ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS_SET_SELECTED_CAMPAIGNS',
  SET_SELECTED_EMAILS: 'ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS_SET_SELECTED_EMAILS',
  SET_REDIRECT_URL: 'ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS_SET_REDIRECT_URL',
  RESET_REDIRECT_URL: 'ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS_REDIRECT_URL',
  SET_EXPORT_BUTTON: 'ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS_SET_EXPORT_BUTTON',
  IS_SEARCH: 'ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS_IS_SEARCH',
};

export const CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS = {
  LOAD: 'CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS_LOAD',
  LOAD_SUCCESS: 'CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS_LOAD_SUCCESS',
  LOAD_FAIL: 'CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS_LOAD_FAIL',
  RESET: 'CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS_RESET',
  SET_EMAILS_BY_FILTER: 'CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS_SET_EMAILS_BY_FILTER',
  SET_DATES_OBJECT: 'CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS_SET_DATES_OBJECT',
  SET_DATES: 'CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS_SET_DATES',
  RESET_DATES: 'CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS_RESET_DATES',
  SET_EXPORT_BUTTON: 'EMAIL_ENGAGEMENT_SET_EXPORT_BUTTON',
  SET_IS_SEARCH: 'CONTACTS_EMAIL_ENGAGEMENT_ANALYTICS_SET_IS_SEARCH',
};
export const ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS = {
  LOAD: 'ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS_LOAD',
  LOAD_SUCCESS: 'ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS_LOAD_SUCCESS',
  LOAD_FAIL: 'ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS_LOAD_FAIL',
  RESET: 'ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS_RESET',
  SET_EMAILS_BY_FILTER: 'ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS_SET_EMAILS_BY_FILTER',
  SET_DATES_OBJECT: 'ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS_SET_DATES_OBJECT',
  SET_DATES: 'ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS_SET_DATES',
  RESET_DATES: 'ACCOUNTS_EMAIL_ENGAGEMENT_ANALYTICS_RESET_DATES',
};

export const ANALYTICS_ACCOUNTS_DASHBOARD = {
  LOAD: 'ANALYTICS_ACCOUNTS_DASHBOARD_LOAD',
  LOAD_SUCCESS: 'ANALYTICS_ACCOUNTS_DASHBOARD_LOAD_SUCCESS',
  LOAD_FAIL: 'ANALYTICS_ACCOUNTS_DASHBOARD_LOAD_FAIL',
  SET_SELECTED_CAMPAIGNS: 'ANALYTICS_ACCOUNTS_DASHBOARD_SET_SELECTED_CAMPAIGNS',
  SET_SELECTED_EMAILS: 'ANALYTICS_ACCOUNTS_DASHBOARD_SET_SELECTED_EMAILS',
  RESET: 'ANALYTICS_ACCOUNTS_DASHBOARD_RESET',
  SET_REDIRECT_URL: 'ANALYTICS_ACCOUNTS_DASHBOARD_SET_REDIRECT_URL',
  RESET_REDIRECT_URL: 'ANALYTICS_ACCOUNTS_DASHBOARD_RESET_REDIRECT_URL',
  SHOW_ENTITIES_COUNT: 'ANALYTICS_ACCOUNTS_DASHBOARD_SHOW_ENTITIES_COUNT',
  DATA: 'ANALYTICS_ACCOUNTS_DASHBOARD_DATA',
  LOAD_STATS: 'ANALYTICS_ACCOUNTS_DASHBOARD_LOAD_STATS',
  LOAD_STATS_FAIL: 'ANALYTICS_ACCOUNTS_DASHBOARD_LOAD_STATS_FAIL',
};

export const ANALYTICS_FILTERS = {
  APPLY: 'ANALYTICS_FILTERS_APPLY',
  RESET: 'ANALYTICS_FILTERS_RESET',
};

export const ANALYTICS_EMAIL_TRENDS = {
  LOAD: 'ANALYTICS_EMAIL_TRENDS_LOAD',
  LOAD_SUCCESS: 'ANALYTICS_EMAIL_TRENDS_LOAD_SUCCESS',
  LOAD_FAIL: 'ANALYTICS_EMAIL_TRENDS_LOAD_FAIL',
  UPDATE_ZOOMLEVEL: 'ANALYTICS_EMAIL_TRENDS_ZOOMLEVEL',
  RESET: 'ANALYTICS_EMAIL_TRENDS_RESET',
};

export const ANALYTICS_CLICK_TRENDS = {
  LOAD: 'ANALYTICS_CLICK_TRENDS_LOAD',
  LOAD_SUCCESS: 'ANALYTICS_CLICK_TRENDS_LOAD_SUCCESS',
  LOAD_FAIL: 'ANALYTICS_CLICK_TRENDS_LOAD_FAIL',
  UPDATE_ZOOMLEVEL: 'ANALYTICS_CLICK_TRENDS_ZOOMLEVEL',
  RESET: 'ANALYTICS_CLICK_TRENDS_RESET',
};

export const PREFERENCE_MANAGEMENT = {
  LOAD_PREFERENCES: 'PREFERENCE_MANAGEMENT_LOAD_PREFERENCES',
  LOAD_SUCCESS_PREFERENCES: 'PREFERENCE_MANAGEMENT_LOAD_SUCCESS_PREFERENCES',
  LOAD_FAIL_PREFERENCES: 'PREFERENCE_MANAGEMENT_LOAD_FAIL_PREFERENCES',
  CHANGE_UNSUBALL: 'PREFERENCE_MANAGEMENT_CHANGE_UNSUBALL',
  CHANGE_ACTION: 'PREFERENCE_MANAGEMENT_CHANGE_ACTION',
};
